import React from "react";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Row, Col } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import { DocumentTitle, PageHeader } from "components/common";
import AuditLogEntries from "auditlog/AuditLogEntries";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import AuditLogPageNavigation from "./AuditLogPageNavigation";
const AuditLogPage = () => {
  const { t } = useTranslation("enterprise_auditlog");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("page.document_title") }, /* @__PURE__ */ React.createElement(AuditLogPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("page.title"),
      documentationLink: {
        title: t("documentation_title"),
        path: DocsHelper.PAGES.AUDIT_LOG
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("page.description", { productName }))
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: t("license.title"),
      title: t("license.text"),
      licenseSubject: LICENSE_SUBJECTS.auditlog,
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(AuditLogEntries, null))));
};
export default AuditLogPage;
